(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete as MuiAutocomplete } from '@material-ui/lab';
import { TextField as MuiTextField } from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import { withTheme } from '@material-ui/core/styles';

var Autocomplete = function Autocomplete(props) {
  var options = props.options,
      label = props.label,
      multiple = props.multiple,
      freeSolo = props.freeSolo;

  var theme = props.theme,
      value = props.value,
      onChange = props.onChange,
      TextFieldProps = props.TextFieldProps,
      muiAutocompleteProps = _objectWithoutProperties(props, ["theme", "value", "onChange", "TextFieldProps"]);

  var handleChange = function handleChange(e, newValue, reason) {
    var designiValue = multiple ? newValue.map(function (v) {
      return v.value;
    }) : newValue === null ? null : freeSolo && reason === 'create-option' ? newValue : newValue.value;
    onChange(e, designiValue, reason);
  };

  var muiValue = multiple ? (value || []).map(function (v) {
    return options.find(function (o) {
      return o.value === v;
    });
  }) : options.find(function (o) {
    return o.value === value;
  }) || (freeSolo ? value : null);
  return React.createElement(MuiAutocomplete, _extends({
    renderInput: function renderInput(params) {
      return React.createElement(MuiTextField, _extends({}, params, TextFieldProps, {
        label: label,
        variant: "outlined"
      }));
    },
    ChipProps: {
      deleteIcon: React.createElement(Clear, {
        stroke: theme.palette.background.paper,
        strokeWidth: 1
      })
    },
    getOptionLabel: function getOptionLabel(option) {
      return typeof option === 'string' ? option : option.text;
    },
    value: muiValue,
    onChange: handleChange
  }, muiAutocompleteProps));
};

Autocomplete.propTypes = {
  /** Props applied to the [`TextField`](https://material-ui.com/api/text-field/) component. */
  // eslint-disable-next-line react/forbid-prop-types
  TextFieldProps: PropTypes.object,
  options: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    value: PropTypes.string
  })),
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  multiple: PropTypes.bool,
  label: PropTypes.string
};
Autocomplete.defaultProps = {
  options: [],
  multiple: false,
  freeSolo: false
};

var _default = withTheme(Autocomplete);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Autocomplete, "Autocomplete", "/home/vsts/work/1/s/src/components/inputs/Autocomplete.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/inputs/Autocomplete.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();